export default __webpack_public_path__ + "static/media/logo-footer.d3c3fcde.png";